export const SPOTLIGHT_NAMES = {
	sidebarItems: 'eoc-team-dashboard_sidebar_items',
};
